// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-cascader-panel .el-radio {\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  position: absolute;\n  top: 10px;\n  left: 5px;\n}\n.viewer-container {\n  z-index: 9999 !important;\n}\n/* 隐藏此刻\n.el-picker-panel__footer .el-button--text.el-picker-panel__link-btn {\n  display: none;\n} */\n", ""]);
// Exports
module.exports = exports;
